import styled from 'styled-components'
import { Spin } from 'antd'


export const ShortListModalImg = styled.div`
 text-align: center;
 margin-bottom: 25px;
`;
export const ModalText = styled.div`
color: #010E30;
text-align: center;
font-family: Plus Jakarta Sans;
font-size: 16px;
font-style: normal;
font-weight: 700;
margin-bottom: 25px;
`
export const ButtonDiv = styled.div`
display:flex;
align-items: center;
justify-content: center;
gap:30px;
`
export const StyledSpin = styled(Spin)`
  .ant-spin-dot-item {
    background-color: #5db594;
  }
`;
